<div class="resume-header">
  <span
    *ngIf="showTitle"
    class="resume-title"
  >Resume</span>
  <a
    [queryParams]="{ module: modules.CANDIDATE, type: types.RESUME }"
    [routerLink]="['', { outlets: { modal: ['attachments'] }}]"
    [skipLocationChange]="true"
    *mojoHasPrivilege="privileges.candidates.edit"
    class="btn btn-link update-resume"
  >
    <mat-icon class="middle-icon">backup</mat-icon>
    <span class="update-resume-text">Update resume</span>
  </a>
</div>
